'use client'
import HgToggle from '~/design-system/hg/components/HgToggle'
import {type HgPricingCardsHeadingProps} from './types'

export default function HgPricingCardsHeading({
  headingEyebrow,
  headingToggleLabel,
  checked,
  onCheckedChange,
}: HgPricingCardsHeadingProps) {
  return (
    <div className="flex items-center justify-between px-s5 py-s3 text-text-subdued">
      {headingEyebrow && (
        <div className="hidden arcadia-ui-4 md:block">{headingEyebrow}</div>
      )}
      <HgToggle
        label={headingToggleLabel}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
    </div>
  )
}
